import { buildProps } from '@hongluan-ui/utils'

import type { ExtractPropTypes } from 'vue'
import type Step from './item.vue'

export const stepProps = buildProps({
  /**
   * @description step title
   */
  title: {
    type: String,
    default: '',
  },
  /**
   * @description step description
   */
  description: {
    type: String,
    default: '',
  },
  /**
   * @description current status. It will be automatically set by Steps if not configured.
   */
  status: {
    type: String,
    default: '',
    values: ['', 'wait', 'process', 'finish', 'error', 'success'],
  },
} as const)
export type StepProps = ExtractPropTypes<typeof stepProps>
export type StepInstance = InstanceType<typeof Step>
